 <template>
 <div class="usingRemarkPage"> 
	<!--
    <mu-appbar class="XR-head" title="优惠券使用说明">
      <mu-icon-button v-on:click="GoBack" icon=":fa fa-angle-left" slot="left"/>
      <mu-icon-menu icon=":fa fa-mymore" slot="right">
        <mu-menu-item to="/usercenter/index" title="个人中心"/>
        <mu-menu-item to="/" title="首页"/>
        <mu-menu-item to="/retail/cart" title="购物车"/>
      </mu-icon-menu>
    </mu-appbar>
	-->
	<XR-head titleText="优惠券使用说明" :rightShow="true" ref="" class="title" >
      
    </XR-head>
    <div class="top"></div>
    <div class="content">
      <div style="width:100%;height:125px;float:left;"></div>
      <div style="width:25%;height:60px;float:left;"></div>
      <div class="content_price">
          {{couponList.Money}}元
      </div>
    </div>
    <div class="footer">
      <div class="content">
        <div class="content_title">
          <div style="width:25%;height:100%;float:left;"></div>
              <div class="content_title_txt">
                  优惠券使用说明
              </div>
          </div>
        <div class="content_remark">
        <div class="content_remark_li">
            <ul>
              <li><span style="font-size:15px;font-weight:900;"> · </span>优惠券使用时间：
                <p>{{couponList.StartTime}}-{{couponList.EndTime}}</p>
              </li>
              <li><span style="font-size:15px;font-weight:900;"> · </span>优惠券使用门槛：
                <p>一次性购买满{{couponList.FullMoney}}元可使用</p>
              </li>
              <li><span style="font-size:15px;font-weight:900;"> · </span>优惠券使用说明：
                <p v-html="couponList.Content"></p>
              </li>
            </ul>
          </div>
          <div class="content_remark_p">
            活动最终解释权归和诚旭日电子商务湖北有限公司所有。
          </div>
        </div>
      </div>
      <div class="footer_foot">
        <div style="white-space:nowrap;display:inline-block;">这些宝贝都可以用券的呦~~</div>
		<div style="border-bottom: 1px dotted #fff;"></div>
        <!--<hr>-->
      </div>
    </div>
    <div class="pro-list">
      <div class="item" v-for=" item in shopOrderList" :key="item" >
        <template >
          <router-link :to="'/retail/productDetail?skuId='+item.SkuId">
          <div class="top">
            <img  :src="item.ImagePath" :style="{height: imgHeight+'px'}" v-if="item.ImagePath" />
			<img  src="/static/index/index-item-default.png" :style="{height: imgHeight+'px'}" v-if="!item.ImagePath" />
          </div> 
          <div class="text">
            <div class="money">
              <p class="price">￥<span>{{item.SalePrice}}</span></p>
              <p class="del-price">￥{{item.Price}}</p>
              <p class="shopname">{{item.ProductName}}</p>
			  <p class="skuname">{{item.SkuName}}</p>
            </div>
          </div>
          </router-link>   
        </template>
      </div>
      <div v-if="isShowLastDefault" class="item" :style="{width:itemWidth+'px', marginBottom:0,height:imgHeight+68+'px'}">
        <img src="/static/index/index-item-default.png" style="display:block;width:100%;" :style="{height:imgHeight+68+'px'}"/>
      </div>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
    <XR-signin ref="XRsigin" @onClose="readSignInfo"></XR-signin>
  </div>
 </template>
<script>
export default {
  data(){
    return {
      isLogin:false,
      shopOrderList:[],
      couponList:[],
      sWidth : document.documentElement.clientWidth,
      isShowLastDefault:false,
      imgHeight: 0
    }
  },
  mounted(){
    this.WapCouponDetail()
    this.imgHeight = this.sWidth*0.49  
  },
  methods:{   
    WapCouponDetail(){
      var ths = this
      ths.$post('/Shop/CouponServer/WapCouponDetail',{id: this.$route.query.id}
        ).then(function (res) {
          if(res.IsSuccess){
            ths.couponList = res.Data
            ths.shopOrderList=res.Data.Goods
            ths.isShowLastDefault = ths.shopOrderList.length % 2==1?true:false
          }
        })        
    }, 
    GoBack(){
      var auth = this.$store.state.baw.BtnAuth
      if(auth && auth.indexOf('back')>=0){        
        var appClient = window.localStorage.appClient
        if(appClient){
          if(appClient == 'ios'){
            window.webkit.messageHandlers.ajax.postMessage({fun:'back'})
          }else{
            ajax.back()
          }
        }else{
          this.$router.goBack()
        }      
      }
      else{
        this.$router.goBack()
      }
    }
  }
}
</script>
<style>
.usingRemarkPage {height: auto;}
/* 顶部样式开始 */
.usingRemarkPage .top{
  width: 100%;
}
/* 顶部样式结束 */
/* 中间样式开始 */
.usingRemarkPage .content{
  width: 100%;
  height: 31%;
  background-image: url('/static/XRGcoupon5.png');
  background-size: 100% 100%;
  /* border:1px solid; */
}
.usingRemarkPage .content .content_price{
  width: 50%;
  height: 60px;
  color:white;
  line-height: 60px;
  font-size: 50px;
  font-weight: 400;
  background-image: url('/static/XRGcoupon8.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  text-align: center;
  float:left;
}
/* 中间样式结束 */
/* 底部样式开始 */
.usingRemarkPage .footer{
  width: 100%;
  height: auto;
  background-color: #ED2645;
  /* border:1px solid; */
  padding:10px; 
}
.usingRemarkPage .footer .content{
  width: 100%;
  height: 90%;
  background-image: url('/static/XRGcoupon6.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.usingRemarkPage .footer .content .content_title{
  width: 100%;
  height: 12%;
  text-align: center;
  padding: 10px;
}
.usingRemarkPage .footer .content .content_title .content_title_txt{
  width: 50%;
  height: 100%;
  font-weight: 600;
  line-height: 38px;
  font-size: 18px;
  color: #E62329;
  background-image: url('/static/XRGcoupon7.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin:0px auto 0px auto;
  text-align:center;
}
.usingRemarkPage .footer .content .content_remark{
  width: 95%;
  height: 80%;
  color: white;
  margin: 5px  10px 5px 30px;
}
.usingRemarkPage .footer .content .content_remark .content_remark_li{
  width: 88%;
}
.usingRemarkPage .footer .content .content_remark .content_remark_p{
  height: 5%;
  float: right;
  font-size: 12px;
  -webkit-transform-origin-x: 0;
  -webkit-transform: scale(0.90);
}
.usingRemarkPage .footer .content .content_remark ul li p{
  line-height: 25px;
  font-size: 10px;
}
.usingRemarkPage .footer .content .content_remark ul li{
  margin: 5px;
  list-style: none;
}
.usingRemarkPage .footer .footer_foot{
  width: 100%;
  /* border:1px solid; */
  text-align: center;
  line-height: 30px; 
  margin-top:15px;
  color: white;
}
/* 底部样式结束 */
/* 底部提示样式开始 */
/* 底部提示样式结束 */
/* 推荐商品列表样式开始 */
.usingRemarkPage .XR-head{
  /* position: fixed; */
  background-color: #474a4f;
  color: #fff;
  box-shadow: none;
}
.usingRemarkPage .banner{width:100%;display:block;}
.usingRemarkPage .bannerDiv a{  height: 146px;  width: 100%;}
.usingRemarkPage .bannerDiv a::before{  content: "";  position: absolute;  width: 140px;  height: 146px;  top: 0;  left: -10px;  overflow: hidden;  transform: skewX(-40deg);  z-index: 10;  background: -webkit-linear-gradient(left, rgba(255,255,255,0)0, rgba(255,255,255,0.2)50%, rgba(255,255,255,0)100%);}
.usingRemarkPage .bannerDiv a::before {  animation: pencil 4s infinite;	-webkit-animation: pencil 4s infinite;  transition: left 0.5s ease 0s; }
@keyframes pencil{	0% {left: -10;}  100% {left: 150%; }}
@-webkit-keyframes pencil /* Safari and Chrome */{	0% {left: -10;}  100% {left: 150%; }}
.usingRemarkPage .ph-nav{  padding:.8rem 0;  background:white;  overflow: hidden;}
.usingRemarkPage .ph-nav li{  float:left;  width:25%;  list-style: none;}
.usingRemarkPage .ph-nav li .font{  text-align: center;  width: 40px;  height: 40px;  line-height: 45px; margin: 0px auto;}
.usingRemarkPage .ph-nav li .font.one{  background: url('/static/BAW/member.png');  background-size: 100% 100%;  transition: 1s;  transform: scale(0.8);  animation: myfirst 1s infinite;	-webkit-animation: myfirst 1s infinite;  animation-direction:alternate-reverse;}
@keyframes myfirst{	0% {transform: scale(0.8);}  50% {transform: scale(0.9);}  100% {transform: scale(1);}}
@-webkit-keyframes myfirst /* Safari and Chrome */{	0% {transform: scale(0.8);}  50% {transform: scale(0.9);}  100% {transform: scale(1);}}
.usingRemarkPage .ph-nav li .font.two{  background: url('/static/BAW/zhuanqu.png');  background-size: 100% 100%;}
.usingRemarkPage .ph-nav li .font.three{  background: url('/static/BAW/bangzhu.png');  background-size: 100% 100%;}
.usingRemarkPage .ph-nav li .font.four{  background: url('/static/BAW/duihuan.png');  background-size: 100% 100%;  transform: scale(0.8);  animation: myfirst 1s infinite;	-webkit-animation: myfirst 1s infinite;  animation-direction:alternate-reverse;}
@keyframes myfirst{	from {transform: scale(0.8);}	to {transform: scale(1);}}
@-webkit-keyframes myfirst /* Safari and Chrome */{	from {transform: scale(0.8);}	to {transform: scale(1);}}
.usingRemarkPage .ph-nav li .font .fa{  font-size: 18px;  color: #fff;}
.usingRemarkPage .ph-nav li img{ width:30%; padding:0; margin:0; display:block; margin:0 auto;}
.usingRemarkPage .ph-nav li em{  font-size: .75rem;  line-height: 1.0rem;  color: #5A5655;  display:block;  text-align:center;  font-style: normal;  margin-top: 5px;}
.usingRemarkPage .ad-list { overflow:hidden; margin-bottom:0.2rem;}
.usingRemarkPage .ad-list li { float:left; width:50%; list-style: none;}
.usingRemarkPage .ad-list li img { width:100%; display:block;}
.usingRemarkPage .pro-list { background:#ED2844;display: inline-block;}
.usingRemarkPage .pro-list .item { width:49%; float:left; margin-bottom:5px; background:white;margin-right: 1.5px;margin-left: 1.5px;}
.usingRemarkPage .pro-list .item.rigthmargin { margin-right:2%;}
.usingRemarkPage .pro-list .item .top { position:relative;}
.usingRemarkPage .pro-list .item .top img { width:100%; display:block;}
.usingRemarkPage .pro-list .item .top .dk { position:absolute; top:4px; right:4px; color:red;   text-align:center;}
.usingRemarkPage .pro-list .item .top .dk span { font-size:12px; display:block; height:14px; line-height:14px; font-weight:700;}
.usingRemarkPage .pro-list .text { padding:5px;height: 88px;}
.usingRemarkPage .pro-list .text .money { font-size:12px; overflow:hidden; margin:5px 0;} 
.usingRemarkPage .pro-list .text .money .price { float:left;color:Red;  padding-left:5px; line-height:1.0rem;}
.usingRemarkPage .pro-list .text .money .price span { font-size:16px; font-weight:700;}
.usingRemarkPage .pro-list .text .money .del-price { float:left; color:#A0A0A0; text-decoration:line-through; margin-left:10px; line-height:18px;}
.usingRemarkPage .pro-list .text .money .shopname{float:left;color: black;line-height: 18px;margin-left:6px;
/* word-wrap:break-word; */
overflow: hidden;
text-overflow: ellipsis;
width:98%;
height: 20px;
}
.usingRemarkPage .pro-list .text .money .skuname{float:left;color:#A0A0A0;line-height: 18px;margin-left:6px;
display: -webkit-box;
-webkit-box-orient: vertical;
-webkit-line-clamp: 2;
overflow: hidden;
width:98%;
height: 40px;
}

.usingRemarkPage .pro-list .item .name {color: #000;width:100%;overflow:hidden;height:30px;line-height:18px;font-size:14px;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;}
.usingRemarkPage .pro-list .item .buycount { margin:5px 0; width:100%; overflow:hidden; height:16px; text-align:right; color:#999; line-height:16px; font-size:12px;}
.usingRemarkPage .signin { height:70px; background:#F9CC9D; overflow:hidden;}
.usingRemarkPage .signin .left { float:left;margin-left:5px;}
.usingRemarkPage .signin .left .box-open { float:left; margin-top:6px; width:55px;}
.usingRemarkPage .signin .left .info { float:left; margin-top:21px; margin-left:4px;}
.usingRemarkPage .signin .left .info .desc { font-size:12px; overflow:hidden; }
.usingRemarkPage .signin .left .info .desc .special { font-size:16px;line-height:16px; color:#FF0000; float:left;}
.usingRemarkPage .signin .left .info .desc .normal { font-size:12px; line-height:14px; margin-left:5px; float:left;}
.usingRemarkPage .signin .left .info .tip { font-size:12px; line-height:12px; margin-top:3px;}
.usingRemarkPage .signin .right { float:right; margin-right:5px;}
.usingRemarkPage .signin .right .signin-btn { float:left; margin-top:14px; width:46px;}
.usingRemarkPage .signin .right .btn { float:left; margin-top:22px;margin-left:2px;}
.usingRemarkPage .signin .right .btn .btn-text { font-size:12px;line-height:12px;}
.usingRemarkPage .signin .right .btn .award { font-size:12px;line-height:12px; margin-top:6px;}  
.usingRemarkPage .XR-head .mu-appbar-title span {color:#fff;}
.usingRemarkPage .mu-appbar .right .mu-icon-button>div {background: rgba(71, 74, 79, 0.3);border-radius: 50%;width: 24px;height: 24px;text-align: center;}
.usingRemarkPage .mu-appbar .right .mu-icon-button .fa-mymore{font-size: 24px;}

</style>



// WEBPACK FOOTER //
// src/pages/retail/coupon/couponUsingRemark.vue